export default __webpack_public_path__ + "svg/calendar/2027/4/mayo.svg?d3a0bd22";